import { RouteStateFixture } from '@/app/Components/RouteStateFixture';
import type { RouteDataState } from '@/app/lib/routeStateContract';

/**
 * Parent integration surface: render this before the existing route's data hooks
 * when `auditFixture` is a RouteDataState. Kept separate while Dining is protected.
 */
export function DiningAuditFixture({ state }: { state: RouteDataState }) {
  return <RouteStateFixture route="dining" state={state} fixtureOnly />;
}
